module.exports = __webpack_public_path__ + "static/media/mmDessert1.98ba0d2d.jpg";